import ResourceLinkDTO from 'models/dto/resourceLinkDTO';

export class DocumentProviderCapabilitiesDTO {
  browse: boolean;

  linkExisting: boolean;

  upload: boolean;

  createFolder: boolean;

  download: boolean;

  embedPreview: boolean;

  officeOnlinePreview: boolean;

  webLink: boolean;

  thumbnail: boolean;

  versions: boolean;

  publish: boolean;

  approvals: boolean;

  readConfirmations: boolean;

  pagesKind: boolean;

  pageEdit: boolean;

  docxEdit: boolean;

  providerSearch: boolean;

  deleteContent: boolean;

  customList: boolean;

  wholeList: boolean;

  writeProbe: boolean;

  contentIngest: boolean;

  requiresConnection: boolean;

  supportsDomainDelegation: boolean;

  supportsUserDelegation: boolean;

  pdfConversion: boolean;

  constructor() {
    this.browse = false;
    this.linkExisting = false;
    this.upload = false;
    this.createFolder = false;
    this.download = false;
    this.embedPreview = false;
    this.officeOnlinePreview = false;
    this.webLink = false;
    this.thumbnail = false;
    this.versions = false;
    this.publish = false;
    this.approvals = false;
    this.readConfirmations = false;
    this.pagesKind = false;
    this.pageEdit = false;
    this.docxEdit = false;
    this.providerSearch = false;
    this.deleteContent = false;
    this.customList = false;
    this.wholeList = false;
    this.writeProbe = false;
    this.contentIngest = false;
    this.requiresConnection = false;
    this.supportsDomainDelegation = false;
    this.supportsUserDelegation = false;
    this.pdfConversion = false;
  }
}

export class DocumentProviderDescriptorDTO {
  providerType: number;

  name: string;

  capabilities: DocumentProviderCapabilitiesDTO;

  enabled: boolean;

  constructor() {
    this.providerType = 0;
    this.name = '';
    this.capabilities = new DocumentProviderCapabilitiesDTO();
    this.enabled = false;
  }
}

export class DocumentConnectionDTO {
  documentConnectionId: number;

  providerType: number;

  name: string;

  status: number;

  /** DocumentConnectionAuthModes: 0 TenantCredential, 1 DomainDelegated (Google Workspace), 2 UserDelegated. */
  authMode: number;

  isAuthorized?: boolean;

  config?: string;

  /** Write-only: the server never returns a stored credential. */
  authData?: string;

  hasAuthData: boolean;

  lastTestedDate?: string;

  created?: string;

  createdById?: string;

  constructor() {
    this.documentConnectionId = -1;
    this.providerType = 0;
    this.name = '';
    this.status = 1;
    this.authMode = 0;
    this.hasAuthData = false;
  }
}

/** A user's own grant on a user-delegated connection, as the API lists it: never a token. */
export class DocumentConnectionGrantDTO {
  documentConnectionId: number;

  connectionName: string;

  providerType: number;

  isAuthorized?: boolean;

  lastTestedDate?: string;

  created?: string;

  constructor() {
    this.documentConnectionId = -1;
    this.connectionName = '';
    this.providerType = 0;
  }
}

/** The provider's authorization page to open in a popup. */
export class DocumentConnectionGrantStartDTO {
  url: string;

  constructor() {
    this.url = '';
  }
}

/** What the callback page handed this window: the provider's code and the state of the person's own flow. */
export class DocumentConnectionGrantCompleteDTO {
  code: string;

  state: string;

  constructor() {
    this.code = '';
    this.state = '';
  }
}

export class DocumentConnectionTestResultDTO {
  success: boolean;

  message?: string;

  code?: string;

  accountDisplay?: string;

  constructor() {
    this.success = false;
  }
}

export class ProviderContainerDTO {
  id: string;

  name: string;

  kind?: string;

  hasChildren: boolean;

  /** False when a category cannot be bound to this container itself; a folder inside it is needed. */
  canBeRoot: boolean;

  constructor() {
    this.id = '';
    this.name = '';
    this.hasChildren = false;
    this.canBeRoot = false;
  }
}

export class ProviderItemDTO {
  id: string;

  name: string;

  browsePath?: string;

  isFolder: boolean;

  mimeType?: string;

  size?: number;

  modified?: string;

  webUrl?: string;

  canDownload: boolean;

  constructor() {
    this.id = '';
    this.name = '';
    this.isFolder = false;
    this.canDownload = false;
  }
}

export class ProviderItemPageDTO {
  items: ProviderItemDTO[];

  nextPageToken?: string;

  constructor() {
    this.items = [];
  }
}

export class ProviderItemMetadataDTO {
  linkId: number;

  itemId?: string;

  name?: string;

  mimeType?: string;

  size?: number;

  lastModified?: string;

  webUrl?: string;

  hasError: boolean;

  constructor() {
    this.linkId = -1;
    this.hasError = false;
  }
}

export class ProviderPageContentDTO {
  title?: string;

  markdown?: string;

  html?: string;

  lastModified?: string;

  webUrl?: string;
}

export class ProviderCreateFolderDTO {
  parentFolderId?: string;

  name: string;

  constructor() {
    this.name = '';
  }
}

export class ProviderUploadResultDTO {
  item?: ProviderItemDTO;

  /** Set when the upload was asked to create the library item as well. */
  link?: ResourceLinkDTO;
}
